import { APP_BASE_URL } from '@config/constants';
import type { CookieConsentConfig } from 'vanilla-cookieconsent';

const defaultHosts = APP_BASE_URL.map((x) =>
  new URL(x).hostname.split('.').slice(-2).join('.')
);
const { host } = window.location;

export const cookieConsentConfig: CookieConsentConfig = {
  categories: {
    necessary: {
      enabled: true, // this category is enabled by default
      readOnly: true // this category cannot be disabled
    },
    support: {},
    analytics: {}
  },
  disablePageInteraction: true,
  cookie: {
    expiresAfterDays: 365 * 10,
    domain: `.${
      defaultHosts.find((x) => host === x || host.endsWith(`.${x}`)) ??
      defaultHosts[0]
    }`
  },
  guiOptions: {
    consentModal: {
      equalWeightButtons: false,
      flipButtons: true,
      layout: 'bar'
    },
    preferencesModal: {
      layout: 'bar wide',
      position: 'right',
      flipButtons: true,
      equalWeightButtons: false
    }
  },
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'Your privacy at StreamWork',
          description:
            'We use cookies to improve your workflow, analyze site traffic, and provide real-time support. You can choose which types of cookies you’re comfortable with below.',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject non-essential',
          showPreferencesBtn: 'Customize preferences'
        },
        preferencesModal: {
          title: 'Cookie Preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject non-essential',
          savePreferencesBtn: 'Save my choices',
          closeIconLabel: 'Close',
          sections: [
            {
              title: 'Cookie Usage',
              description:
                'We use cookies to ensure StreamWork remains secure, reliable, and easy to use. Some are essential for our platform to function, while others help us improve the experience for your team.'
            },
            {
              title: 'Strictly Necessary',
              description:
                'These cookies are required for core features like security, account authentication, and session management. They cannot be disabled.',
              linkedCategory: 'necessary'
            },
            {
              title: 'Support & Experience',
              description:
                'These cookies power our integrated support tools, such as live chat and help desk features, allowing us to assist you more effectively.',
              linkedCategory: 'support'
            },
            {
              title: 'Performance & Analytics',
              description:
                'We use analytics tools to understand how you interact with StreamWork. This helps our team identify and fix performance issues, streamline workflows, and prioritize the features you use most.',
              linkedCategory: 'analytics'
            },
            {
              title: 'More Information',
              description:
                'For more details on how we handle your data, please read our <a href="https://www.streamwork.com/privacy-policy" target="_blank">Privacy Policy</a>. If you have questions regarding your choices, you can reach us at <a href="mailto:support@streamwork.com">support@streamwork.com</a>.'
            }
          ]
        }
      }
    }
  }
};
